import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.detail(_ctx.umbuchung)))
  }, {
    append: _withCtx(() => [
      _createVNode(_component_v_list_item_action, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_v_chip, {
              class: "mr-2",
              variant: "outlined",
              size: "x-small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.umbuchung.Bediener), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_chip, {
              color: _ctx.umbuchung.statusColor,
              variant: "outlined"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.umbuchung.date), 1)
              ], undefined, true),
              _: 1
            }, 8, ["color"])
          ])
        ], undefined, true),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list_item_title, null, {
        default: _withCtx(() => [
          _createTextVNode(" an " + _toDisplayString(_ctx.umbuchung.NiederlassungEingehend[0]!.Name1), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_list_item_subtitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.umbuchung.BelegNr), 1)
        ], undefined, true),
        _: 1
      }),
      (_ctx.umbuchung.LKW.length > 0)
        ? (_openBlock(), _createBlock(_component_v_chip, {
            key: 0,
            color: "primary",
            variant: "flat",
            size: "x-small",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "mr-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-truck")
                ], undefined, true),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_ctx.umbuchung.LKW[0].KFZKennzeichen), 1)
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}